<template>
  <div class="dateDisplay">
    <div class="dateHeading">
      {{ label }}
    </div>
    <div class="dateValue">
      {{ showAbbrDate(getRange) }}
    </div>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import dayjs from 'dayjs';

export default {
  name: 'DateDisplay',
  props: [
      'label',
      'range',
      'time'
  ],
  setup () {
    const RMTStore = useRMTStore();
    return {
      RMTStore
    };
  },
  computed: {
    getRange () {
      return this.RMTStore.singleDate;
    }
  },
  methods: {
    showWeekday (d) {
      return dayjs(d).format('dddd');
    },
    showDate (d) {
      return dayjs(d).format('MMM D, YYYY');
    },

    showAbbrDate (d) {
      return dayjs(d).format('MMMM DD, YYYY');
    }
  },
};
</script>

<style scoped>

.dateDisplay {

  display: flex;
  margin-bottom:10px;
  width: 100%;
  height: 40px;
  font-size: .8em;

}

.dateHeading {

  width: 17%;
}

.dateValue {
  width: 100%;
  height: 35px;
  padding: 8px 15px;
  border-radius: 18px;
  color: black;
  font-weight: 550;
  background-color: whitesmoke;

}


.dateValue:hover {
  background-color: #e7e7e7;
}

.date {
  font-weight: 700;
  font-size: .85em;
}

.weekday {
  font-size: .85em;
  transform: translateY(-5px);
}


</style>